/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Demo_Note_DescriptionInputs */

const en_draft_demo_note_description = /** @type {(inputs: Draft_Demo_Note_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two windows. That's it.`)
};

const ar_draft_demo_note_description = /** @type {(inputs: Draft_Demo_Note_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نافذتان فقط. هذا كل شيء.`)
};

const bn_draft_demo_note_description = /** @type {(inputs: Draft_Demo_Note_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দুটি উইন্ডো। এটুকুই।`)
};

const de_draft_demo_note_description = /** @type {(inputs: Draft_Demo_Note_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwei Fenster. Das ist es.`)
};

const es_draft_demo_note_description = /** @type {(inputs: Draft_Demo_Note_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dos ventanas. Eso es todo.`)
};

const fr_draft_demo_note_description = /** @type {(inputs: Draft_Demo_Note_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deux fenêtres. C'est ça.`)
};

const pt_draft_demo_note_description = /** @type {(inputs: Draft_Demo_Note_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas janelas. É isso.`)
};

const zh_draft_demo_note_description = /** @type {(inputs: Draft_Demo_Note_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两个窗口。就是这样。`)
};

const tr_draft_demo_note_description = /** @type {(inputs: Draft_Demo_Note_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İki pencere. İşte bu.`)
};

const ru_draft_demo_note_description = /** @type {(inputs: Draft_Demo_Note_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Два окна. Вот и все.`)
};

const pl_draft_demo_note_description = /** @type {(inputs: Draft_Demo_Note_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dwa okna. To wszystko.`)
};

/**
* | output |
* | --- |
* | "Two windows. That's it." |
*
* @param {Draft_Demo_Note_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const draft_demo_note_description = /** @type {((inputs?: Draft_Demo_Note_DescriptionInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Demo_Note_DescriptionInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_draft_demo_note_description(inputs)
	if (locale === "bn") return bn_draft_demo_note_description(inputs)
	if (locale === "de") return de_draft_demo_note_description(inputs)
	if (locale === "es") return es_draft_demo_note_description(inputs)
	if (locale === "fr") return fr_draft_demo_note_description(inputs)
	if (locale === "pt") return pt_draft_demo_note_description(inputs)
	if (locale === "zh") return zh_draft_demo_note_description(inputs)
	if (locale === "tr") return tr_draft_demo_note_description(inputs)
	if (locale === "ru") return ru_draft_demo_note_description(inputs)
	if (locale === "pl") return pl_draft_demo_note_description(inputs)
	return en_draft_demo_note_description(inputs)
});